import { AfterContentInit, Component, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { CustomerObjectContactDto, CustomerObjectWithContactsDto, getContragentContactDisplayName as resolveContragentContactDisplayName } from "../../../models/customerObject/customer-object-with-contacts.dto";
import { KeyValueObject } from "../../../models/core/KeyValueObject";
import { CustomerObjectsService } from "../../../../categories/customer-objects/customer-objects.service";
import { NotificationService } from "../../../../core/services/notification.service";
import { NotificationType } from "../../../../core/services/notification-type";
import { GridComponent } from "@progress/kendo-angular-grid";
import { AddressSuggestion } from "../../../models/dadata-address/address-suggestion";
import { DaDataAddressComponent } from "../../dadata-address/dadata-address.component";
import { DropdownListCountryPhoneMasksComponent } from "../../dropdownlist-country-phone-masks/dropdownlist-country-phone-masks.component";
import { DialogService } from "@progress/kendo-angular-dialog";
import { AddressClarificationComponent } from "../../adresses/address-clarification/address-clarification.component";
import { UsersService } from "../../../../admin/users/users.service";
import { LookupService } from "../../../services/lookup.service";
import { DropDownFilterSettings } from "@progress/kendo-angular-dropdowns";
import { DataSourceRequestState } from "@progress/kendo-data-query";
import { forkJoin } from "rxjs";

@Component({
	selector: 'create-customer-object',
	templateUrl: './create-customer-object.component.html',
	styleUrls: [
		'./create-customer-object.component.scss',
		'../../../../../vendor/libs/angular2-ladda/angular2-ladda.scss',
		'../../../../../vendor/libs/ngx-perfect-scrollbar/ngx-perfect-scrollbar.scss',
	]
})
export class CreateCustomerObjectComponent implements AfterContentInit {

	@ViewChild("contactsGrid") contactsGrid: GridComponent;
	@ViewChild("dadataAddressControl") dadataAddressControl: DaDataAddressComponent;
	@ViewChild('countryPhoneMasksComponent') countryPhoneMasksComponent: DropdownListCountryPhoneMasksComponent;

	loading: boolean = false;

	clientDefaultItem: KeyValueObject = new KeyValueObject(0, 'Не выбрано');
	serviceCenterDefaultItem: KeyValueObject = new KeyValueObject(null, '(нет)');
	serviceCenters: KeyValueObject[] = [];
	dropDownFilterSettings: DropDownFilterSettings = { caseSensitive: false, operator: 'contains' };
	cellPhoneMask: string = "+7 (000) 000-00-00";
	public rules: { [key: string]: RegExp } = {
		'0': /\d/
	};

	@Input() selectedCustomerObject: CustomerObjectWithContactsDto;
	@Input() customerObjects: KeyValueObject[] = [];
	@Input() contragentId: number;
	@Input() isEditing: boolean = false;
	@Input() commitChanges: boolean = true;
	@Input() showEmail: boolean = false;

	@Output() onCancelEvent: EventEmitter<any> = new EventEmitter();
	@Output() onContinueEvent: EventEmitter<CustomerObjectWithContactsDto> = new EventEmitter<CustomerObjectWithContactsDto>();

	entity: CustomerObjectWithContactsDto;

	constructor(
		public customerObjectsService: CustomerObjectsService,
		public notificationService: NotificationService,
		public dialogService: DialogService,
		private usersService: UsersService,
		private lookupService: LookupService
	) { }

	ngAfterContentInit(): void {
		this.entity = {
			customerObjectId: this.selectedCustomerObject.customerObjectId,
			name: this.selectedCustomerObject.name,
			address: this.selectedCustomerObject.address,
			addressDescription: this.selectedCustomerObject.addressDescription,
			contragentId: this.contragentId,
			contragentName: this.selectedCustomerObject.contragentName,
			serviceCenterId: this.selectedCustomerObject.serviceCenterId,
			serviceCenterName: this.selectedCustomerObject.serviceCenterName,
			contacts: this.selectedCustomerObject.contacts.map(x => {
				return {
					contactId: x.contactId,
					fullName: x.fullName,
					phoneNumber: x.phoneNumber,
					email: x.email,
					isContragentContact: x.isContragentContact
				}
			})
		} as CustomerObjectWithContactsDto;

		if (this.dadataAddressControl) {
			this.dadataAddressControl.initValue(this.entity.address);
		}

		this.loadServiceCenters();
	}

	loadServiceCenters() {
		forkJoin([
			this.customerObjectsService.getAssignableServiceCenters(),
			this.usersService.getLookupUserServiceCenters()
		]).subscribe(([assignable, userServiceCenters]) => {
			const items = assignable || [];
			const defaultSc = (userServiceCenters || []).find(x => x.isDefault);

			const applyItems = (result: KeyValueObject[]) => {
				this.serviceCenters = result;
				if (!this.entity.serviceCenterId && defaultSc) {
					this.entity.serviceCenterId = defaultSc.id;
				}
			};

			if (this.entity && this.entity.serviceCenterId
				&& !items.some(s => s.id === this.entity.serviceCenterId)) {
				const scState: DataSourceRequestState = {
					filter: {
						logic: 'and', filters: [
							{ field: 'ServiceCenterId', operator: 'eq', value: this.entity.serviceCenterId },
						]
					}
				};

				this.lookupService.getData("service-centers", scState).subscribe(data2 => {
					let missing = data2.find(f => f.id === this.entity.serviceCenterId);
					if (missing) {
						missing.disabled = true;
						applyItems([...items, missing]);
					} else if (this.entity.serviceCenterName) {
						applyItems([...items, new KeyValueObject(this.entity.serviceCenterId, this.entity.serviceCenterName)]);
					} else {
						applyItems(items);
					}
				});
			} else {
				applyItems(items);
			}
		});
	}

	itemDisabledSc(itemArgs: { dataItem: KeyValueObject; index: number }) {
		return itemArgs.dataItem.disabled;
	}

	manualCorrectCoordinates() {
		this.entity.ignoreAddressCheck = true;
		this.showAddressClarification(this.isEditing);
	}

	showAddressClarification(isEditing: boolean) {
		const dialogRef = this.dialogService.open({
			content: AddressClarificationComponent,
			width: '80%',
			height: '820px',
			minWidth: '800px'
		});
		const addressClarification = <AddressClarificationComponent>dialogRef.content.instance;

		addressClarification.height = 460;
		addressClarification.address = this.entity.address;
		addressClarification.onCancelEvent.subscribe(() => {
			this.loading = false;
			dialogRef.close();
		});
		addressClarification.onContinueEvent.subscribe(yandexModel => {

			this.entity.yandexModel = yandexModel;

			if (isEditing) {
				this.customerObjectsService.updateCustomerObjectWithContacts(this.entity).subscribe((resp) => {
					this.entity.yandexModel = null;
					this.refreshAndContinue(this.entity.customerObjectId, resp.isSuccessful, resp.errorDescription);
					dialogRef.close();
				}, () => {
					this.loading = false;
					this.entity.yandexModel = null;
				});
			} else {
				this.customerObjectsService.createCustomerObjectWithContacts(this.entity).subscribe((resp) => {
					this.entity.yandexModel = null;
					this.entity.customerObjectId = resp.data.id;
					this.refreshAndContinue(this.entity.customerObjectId, resp.isSuccessful, resp.errorDescription);
					dialogRef.close();
				}, () => {
					this.loading = false;
					this.entity.yandexModel = null;
				});
			}
		});
	}

	save() {
		this.loading = true;
		this.entity.contragentId = this.contragentId;
		if (this.isEditing) {
			if (this.commitChanges) {
				this.customerObjectsService.updateCustomerObjectWithContacts(this.entity).subscribe((resp) => {
					if (resp.isSuccessful) {
						if (!resp.data.addressOk) {
							this.showAddressClarification(this.isEditing);
							return;
						}
					}

					this.refreshAndContinue(this.entity.customerObjectId, resp.isSuccessful, resp.errorDescription);

				}, () => this.loading = false);
			}
			else {
				this.loading = false;
				this.onContinueEvent.emit(this.entity);
			}
		}
		else {
			if (this.commitChanges) {
				this.customerObjectsService.createCustomerObjectWithContacts(this.entity).subscribe((resp) => {
					if (resp.isSuccessful) {
						if (resp.data.addressOk) {
							this.entity.customerObjectId = resp.data.id;
						} else {
							this.showAddressClarification(this.isEditing);
							return;
						}
					}

					this.refreshAndContinue(resp.data.id, resp.isSuccessful, resp.errorDescription);
				}, () => this.loading = false);
			}
			else {
				this.loading = false;
				this.entity.customerObjectId = 0;
				this.onContinueEvent.emit(this.entity);
			}
		}
	}

	refreshAndContinue(id: number, isSuccessful: boolean, errorMessage: string = null) {
		if (isSuccessful) {
			this.customerObjectsService.getCustomerObjectWithContacts(id).subscribe((getResp) => {
				this.loading = false;
				this.entity = getResp;
				this.onContinueEvent.emit(this.entity);
			}, () => this.loading = false);
		}
		else {
			this.notificationService.error({
				title: 'Ошибка',
				message: errorMessage,
				notificationType: NotificationType.SweetAlert
			});
			this.loading = false;
		}
	}

	editHandler({ dataItem }) {
		this.refreshMask(dataItem);
	}

	cancel() {
		this.onCancelEvent.emit();
	}

	setMask(mask: string, dataItem: CustomerObjectContactDto) {
		this.cellPhoneMask = mask;
		dataItem.phoneNumber = '';
	}

	refreshMask(dataItem: CustomerObjectContactDto) {
		setTimeout(() => {
			this.cellPhoneMask = this.countryPhoneMasksComponent.getAndSetPhoneMask(dataItem.phoneNumber);
		}, 10);
	}

	customerObjectChange(id: number) {
		this.customerObjectsService.getCustomerObjectWithContacts(id).subscribe((resp) => {
			this.entity = resp;
		});
	}

	onAddressChange(value: AddressSuggestion) {
		this.entity.address = value.address;
	}

	createNewContact(): CustomerObjectContactDto {
		var contact = new CustomerObjectContactDto();
		return contact;
	}

	addNewContact() {
		this.contactsGrid.addRow(this.createNewContact());
	}

	public rowClass() {
		return {
			'cursor-pointer': true
		};
	}

	get gridHeight(): number {
		return this.entity.contacts.length * 50 + 100;
	}

	get canCreate(): boolean {
		return this.entity != null &&
			this.entity.name != null && this.entity.name.trim() != '' &&
			this.entity.address != null && this.entity.address.trim() != '' &&
			this.entity.serviceCenterId != null && this.entity.serviceCenterId > 0;
	}

	getContragentContactDisplayName(contact: CustomerObjectContactDto): string {
		return resolveContragentContactDisplayName(this.entity ? this.entity.contragentName : null, contact);
	}
}
